import { LlmHistoryNode } from '@adaptiva/ai/common';
import { Box, IBox, IBoxed } from '@adaptiva/core/space';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'adaLlmHistoryNodeBox'
})
export class LlmHistoryNodeBoxPipe implements PipeTransform {

	public transform(_node: LlmHistoryNode, _componentMap: WeakMap<LlmHistoryNode, IBoxed>): IBox {
		const _component: IBoxed | undefined = _componentMap.get(_node);

		if (!_component)
			return new Box();

		return _component.getBox();
	}

}
